module.exports = __webpack_public_path__ + "img/AUDIO.c5fc43ea.svg";